import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/primeng';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { ContrachequeListDTO } from '../../../shared/dominios/DTO/contracheque-list.DTO';
import { InformacaoContrachequeDTO } from '../../../shared/dominios/DTO/informacoes-contracheque.DTO';
import { ContraChequeAposentadosModel } from '../../../shared/models/contra-cheque-aposentados.model';
import { MesAnoModel } from '../../../shared/models/mes-ano.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { ContrachqueAposentadoPdf } from '../../../shared/services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-aposentados-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { FinanceiroService } from '../../service/financeiro.service';
import { ContrachequeService } from '../service/contracheque.service';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { UtilService } from '../../../shared/util/util.service';
import { ContrachequeDetalhesValoresAposentadosModel } from '../../../shared/models/contracheque-detalhes-valores-aposentados.model';

@Component({
  selector: 'app-contracheque-aposentado',
  templateUrl: './contracheque-aposentado.component.html',
  styleUrls: ['./contracheque-aposentado.component.css']
})
export class ContrachequeAposentadoComponent implements OnInit {


  @BlockUI() blockUi: NgBlockUI;

  cols: any[];

  cdCentrus: number;
  // cdCentrus = 10014;

  componentes: any[] = [1];

  mesesAno: SelectItem[] = [];

  contrachequeList: Array<ContrachequeListDTO> = new Array<ContrachequeListDTO>();
  informacaoContrachequeDTO: InformacaoContrachequeDTO = new InformacaoContrachequeDTO()
  mesAno: string;

  mesAnoModel = new MesAnoModel();

  contraChequeAposentadosModel: ContraChequeAposentadosModel = new ContraChequeAposentadosModel();

  dadosCadastrais: Array<InformacaoContrachequeDTO> = new Array<InformacaoContrachequeDTO>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  page: number;
  param: string;
  outros = false;
  bonus = false;

  constructor(
    private financeiroService: FinanceiroService,
    private utilService: UtilService,
    private contrachequeService: ContrachequeService,
    private _decimalPipe: DecimalPipe,
    private contrachqueAposentadoPdf: ContrachqueAposentadoPdf,
    private authInterceptor: AuthInterceptor,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private router: Router
  ) { }



  ngOnInit() {


    this._gerenciarCodigoIndentificao();

    this.cols = [
      { field: 1, header: 'Verba' },
      { field: 2, header: 'Descrição' },
      { field: 3, header: 'Parcela' },
      { field: 4, header: 'Saldo/Base de Cáculo' },
      { field: 5, header: 'Competência' },
      { field: 6, header: 'Valor' }
    ];


    // 474584
    // 629618
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuFinanceiro';
        }
        this.getPessoasDadosSimplificado();
      })
  }



  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getdDataReferencia();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }



  async getdDataReferencia() {
    this.mesesAno = [];
    try {
      const mesesRetorno = await this.financeiroService.getDataReferenciaAssistido(this.cdCentrus);

      const mesesLimpos = this.utilService.removerValoresDuplicados(mesesRetorno);
      mesesLimpos.map(item => {
        this.mesesAno.push({ label: item, value: item })
      })
      this.mesAno = mesesRetorno[0];
      this.getEspelhoFolhaPagtoWeb(this.mesAno)
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  getContrachequeFuncCentrus(mesAno) {
    this.getEspelhoFolhaPagtoWeb(mesAno);
  }


  getEspelhoFolhaPagtoWeb(mesAno: string) {
    this.informacaoContrachequeDTO = new InformacaoContrachequeDTO();
    this.dadosCadastrais = new Array<InformacaoContrachequeDTO>();
    this.contrachequeList = new Array<ContrachequeListDTO>();


    if (mesAno === null) {
      return;
    }

    this.mesAnoModel = new MesAnoModel(Number(mesAno.split('/')[0]), Number(mesAno.split('/')[1]));

    this.getEspelhoFolhaPagtoWebAposentados(this.mesAnoModel)

  }


  async getEspelhoFolhaPagtoWebAposentados(mesAnoModel: MesAnoModel) {

    try {
      const contracheque = await this.contrachequeService.getEspelhoFolhaPagtoWebAposentados(this.cdCentrus, mesAnoModel.mes, mesAnoModel.ano);


      this.configurarInformacaoContrachqueTela(contracheque);



      if (contracheque.noPessoa) {
        this.contrachequeList.push(
          new ContrachequeListDTO(null, 'Proventos'.toUpperCase(), null, null, null, null));
      }

      this.dadosCadastrais.push(this.informacaoContrachequeDTO)

      contracheque.contrachequeDetalhesValoresAposentadosDTO.map(index => {
        this.configurarProventosTela(index);
      })

      if (contracheque.noPessoa) {
        this.contrachequeList.push(new ContrachequeListDTO(null, 'Descontos'.toUpperCase(), null, null, null, null))
      }

      contracheque.contrachequeDetalhesValoresAposentadosDTO.map(index => {
        this.configurarDescontosTela(index);
      })

      if (this.contrachequeList.length === 0) {
        this.voltarForcada()
      }

    } catch (error) {
      this.toastrService.info('Não foi encontrado contracheque para essa data', 'Não foi encontrado', { timeOut: 8000 })
    }

  }


  private configurarInformacaoContrachqueTela(contracheque: ContraChequeAposentadosModel) {
    this.informacaoContrachequeDTO = new InformacaoContrachequeDTO(
      contracheque.noPessoa,
      null,
      contracheque.sgRegional,
      null,
      this._decimalPipe.transform(Number(contracheque.vlBruto), '1.2-2'),
      this._decimalPipe.transform(Number(contracheque.vlDescontos), '1.2-2'),
      this._decimalPipe.transform(Number(contracheque.vlLiquido), '1.2-2'),
      contracheque.nrBanco,
      contracheque.nrAgencia,
      contracheque.nrContaCorrente,
      contracheque.qtDepIr,
      contracheque.qtDepSalFam,
      this._decimalPipe.transform(Number(contracheque.vlMargem30), '1.2-2'),
      this._decimalPipe.transform(Number(contracheque.vlMargem70), '1.2-2'),
      (contracheque.cdFuncao + ' - ' + contracheque.sgCarreira),
      null,
      null,
      contracheque.dsMensagemInd,
      contracheque.dsMensagemGeral,
      contracheque.nrBenefInss,
      contracheque.nrNossoNumero,
      (contracheque.irIsencaoIr === '1') ? 'Sim' : 'Não',
      contracheque.cdFuncao,
      (contracheque.cdVp + ' / ' + contracheque.qtAnuenio)
    );
  }

  private configurarDescontosTela(index: ContrachequeDetalhesValoresAposentadosModel) {
    if (index.irConsignacao === '1') {
      this.contrachequeList.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerba.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          index.dtCompetencia,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  private configurarProventosTela(index: ContrachequeDetalhesValoresAposentadosModel) {
    if (index.irConsignacao === '3') {
      this.contrachequeList.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerba.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          index.dtCompetencia,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  imprimirPagina() {
    this.contrachqueAposentadoPdf.aposentado(this.mesAno, this.pessoaDadosSimplicadosModel, this.informacaoContrachequeDTO,
      this.contrachequeList);
  }

  voltarForcada(): void {
     this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/contracheque/contracheque-aposentado/contracheque-aposentado.component.ts